import { FC, useEffect, useState } from "react";
import { useAuth } from "oidc-react";
import axios, { AxiosError } from "axios";
import { ModalExpiredSession } from "./ModalExpiredSession";
import useIdleTimeout from "../../hooks/useIdleTimeout";
import { useUIMode } from "../../wms/src/context/UIContext";

interface SessionAdminProps {}

export const SessionAdmin: FC<SessionAdminProps> = () => {
    const authContext = useAuth();
    const { resetMode } = useUIMode();
    const [isOpenExpired, setIsOpenExpired] = useState<boolean>(false);
    const [messageExpired, setMessageExpired] = useState<string>("");

    useEffect(() => {
        axios.defaults.headers.common[
            "Authorization"
        ] = `Bearer ${authContext.userData?.access_token}`;
    }, [authContext.userData]);

    axios.interceptors.response.use(
        (response) => response,
        (error: AxiosError) => {
            if (error.response?.status === 401) {
                alert(
                    "Su sesión ha expirado y su usuario ha sido desconectado.\r\nOprima Aceptar para regresar a la pantalla de inicio de sesión."
                );
                resetMode();
                return authContext
                    .signOutRedirect()
                    .then((_res) => console.log("signOut"))
                    .catch((e) => console.error(e));
            } else {
                return Promise.reject(error);
            }
        }
    );

    useIdleTimeout(15 * 60, () => {
        setIsOpenExpired(true);
        setMessageExpired("Sesión finalizada por inactividad");
    });

    const handleRedirectLogin = () => {
        resetMode();
        authContext
            .signOutRedirect()
            .then((_res) => console.log("signOut"))
            .catch((e) => console.error(e));
    };

    return (
        <ModalExpiredSession
            isOpen={isOpenExpired}
            message={messageExpired}
            handleOnAccept={handleRedirectLogin}
        ></ModalExpiredSession>
    );
};
